// IZNORA Theme JS — Cart Drawer, Mobile Menu, Countdown, Tier Pricing, Sticky ATC, Gallery, Upsell, Toasts
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    initSaleCountdown();
    initGallery();
    initVariantSelection();
    initTierPricing();
    initStickyATC();
    initQtyControls();
    initTabs();
    initFAQ();
    initAjaxCart();
    initCartDrawer();
    initMobileMenu();
    initUpsell();
  }

  // ============================ Sale Countdown ============================
  function initSaleCountdown() {
    const t = document.getElementById('saleTimer');
    if (!t) return;
    const HOURS = parseInt(t.dataset.endHours || '3', 10);
    const KEY = 'iznora-sale-end-' + HOURS + 'h';
    let end = parseInt(localStorage.getItem(KEY) || '0', 10);
    const max = Date.now() + HOURS * 36e5;
    if (!end || end < Date.now() || end > max) {
      end = Date.now() + HOURS * 36e5;
      localStorage.setItem(KEY, end);
    }
    const h = t.querySelector('[data-unit="hours"]');
    const m = t.querySelector('[data-unit="minutes"]');
    const s = t.querySelector('[data-unit="seconds"]');
    const pad = n => String(n).padStart(2, '0');
    const tick = () => {
      const d = Math.max(0, end - Date.now());
      h && (h.textContent = pad(Math.floor(d / 36e5)));
      m && (m.textContent = pad(Math.floor((d % 36e5) / 6e4)));
      s && (s.textContent = pad(Math.floor((d % 6e4) / 1000)));
      if (d === 0) { end = Date.now() + HOURS * 36e5; localStorage.setItem(KEY, end); }
      if (d < 3e5) t.closest('.sale-bar')?.classList.add('sale-bar--urgent');
    };
    tick();
    setInterval(tick, 1000);
  }

  // ============================ Product Gallery ============================
  function initGallery() {
    const main = document.getElementById('GalleryMain');
    const thumbs = document.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        main.src = thumb.dataset.galleryThumb;
      });
    });
  }

  // ============================ Variant Selection ============================
  function initVariantSelection() {
    const productJsonEl = document.getElementById('ProductJSON');
    if (!productJsonEl) return;
    let product;
    try { product = JSON.parse(productJsonEl.textContent); } catch { return; }

    const variantIdInput = document.getElementById('ProductVariantId');
    const variantGroups = document.querySelectorAll('.variants[data-option-index]');
    if (!variantGroups.length) return;

    function getSelected() {
      const opts = [];
      variantGroups.forEach(g => {
        const sel = g.querySelector('.variant.selected');
        opts[parseInt(g.dataset.optionIndex, 10)] = sel ? sel.dataset.variantValue : '';
      });
      return opts;
    }

    function update() {
      const opts = getSelected();
      const match = product.variants.find(v => v.options.every((val, i) => val === opts[i]));
      if (!match) return;
      if (variantIdInput) variantIdInput.value = match.id;
      const priceEl = document.querySelector('[data-product-price]');
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      // Also update compare-at price if variant has one
      const wasEl = document.querySelector('.pd-price__was');
      if (wasEl && match.compare_at_price && match.compare_at_price > match.price) {
        wasEl.textContent = formatMoney(match.compare_at_price);
        wasEl.style.display = '';
      } else if (wasEl) {
        wasEl.style.display = 'none';
      }
      // Recompute tier prices based on new variant price
      recomputeTiers(match.price, match.compare_at_price);
      const atc = document.getElementById('ProductATC');
      if (atc) {
        atc.disabled = !match.available;
        if (!match.available) atc.textContent = 'Sold Out';
      }
    }

    // Recompute Buy 1/2/3 tier prices when variant changes
    function recomputeTiers(unitPrice, unitCompareAt) {
      const tiers = document.querySelectorAll('#pdTiers .pd-tier');
      tiers.forEach(tier => {
        const qty = parseInt(tier.dataset.tier, 10) || 1;
        const disc = parseFloat(tier.dataset.discount) || 0;
        const mult = (100 - disc) / 100;
        const newTotal = Math.round(unitPrice * qty * mult);
        const newWas   = unitPrice * qty;
        const nowEl = tier.querySelector('.pd-tier__price-now');
        const wasEl = tier.querySelector('.pd-tier__price-was');
        if (nowEl) nowEl.textContent = formatMoney(newTotal);
        if (wasEl && disc > 0) wasEl.textContent = formatMoney(newWas);
        // Also update unit-price attribute for sticky atc
        tier.dataset.unitPrice = unitPrice;
      });
      // Re-trigger tier apply to refresh sticky ATC + button text
      const selectedTier = document.querySelector('#pdTiers .pd-tier.selected');
      if (selectedTier && window.__izApplyTier) window.__izApplyTier(selectedTier);
    }

    variantGroups.forEach(g => {
      g.addEventListener('click', e => {
        const variant = e.target.closest('.variant');
        if (!variant) return;
        g.querySelectorAll('.variant').forEach(v => v.classList.remove('selected'));
        variant.classList.add('selected');
        update();
      });
    });
  }

  // ============================ Tier Pricing ============================
  function initTierPricing() {
    const group = document.getElementById('pdTiers');
    if (!group) return;
    const tiers = group.querySelectorAll('.pd-tier');
    const atc = document.getElementById('ProductATC');
    const qtyInput = document.getElementById('ProductQuantity');
    const stickyNow = document.querySelector('[data-sticky-now]');
    const stickyWas = document.querySelector('[data-sticky-was]');

    const apply = tier => {
      tiers.forEach(t => t.classList.remove('selected'));
      tier.classList.add('selected');
      const qty = parseInt(tier.dataset.tier, 10);
      const total = tier.querySelector('.pd-tier__price-now')?.textContent || '';
      const was = tier.querySelector('.pd-tier__price-was')?.textContent || '';
      if (qtyInput) qtyInput.value = qty;
      if (atc) atc.innerHTML = qty === 1 ? 'Add to Cart →' : `Add ${qty} to Cart — ${total} →`;
      if (stickyNow) stickyNow.textContent = total;
      if (stickyWas) stickyWas.textContent = was;
    };

    // Expose so variant selection can re-trigger after price recompute
    window.__izApplyTier = apply;

    tiers.forEach(t => t.addEventListener('click', e => { e.preventDefault(); apply(t); }));
    const initial = group.querySelector('.pd-tier.selected') || tiers[0];
    if (initial) apply(initial);
  }

  // ============================ Sticky ATC ============================
  function initStickyATC() {
    const sticky = document.getElementById('stickyAtc');
    const stickyBtn = document.getElementById('stickyAtcBtn');
    const mainATC = document.getElementById('ProductATC');
    if (!sticky || !stickyBtn || !mainATC) return;
    document.body.classList.add('has-sticky-atc');
    const trigger = document.querySelector('.pd-actions');
    let visible = false;
    const onScroll = () => {
      if (!trigger) return;
      const r = trigger.getBoundingClientRect();
      const should = r.bottom < 0 || r.top > window.innerHeight;
      if (should !== visible) {
        sticky.classList.toggle('is-visible', should);
        sticky.setAttribute('aria-hidden', should ? 'false' : 'true');
        visible = should;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    stickyBtn.addEventListener('click', () => mainATC.click());
  }

  // ============================ Quantity controls ============================
  function initQtyControls() {
    document.querySelectorAll('.qty').forEach(group => {
      const input = group.querySelector('.qty__input');
      if (!input) return;
      // Cart drawer & cart page qty groups are handled by the delegated cart
      // handlers. Binding here too would fire a synthetic 'change' alongside the
      // click → two concurrent /cart/change.js POSTs racing each other
      // (root cause of the "line parameter is invalid" toast).
      if (input.hasAttribute('data-cart-qty')) return;
      group.querySelectorAll('.qty__btn').forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          const action = btn.dataset.action;
          let val = parseInt(input.value, 10) || 1;
          if (action === 'increase') val++;
          else if (action === 'decrease') val = Math.max(1, val - 1);
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  // ============================ Tabs ============================
  function initTabs() {
    const tabs = document.querySelectorAll('.pd-tab-btn');
    const panels = document.querySelectorAll('.pd-tab-panel');
    if (!tabs.length) return;
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        panels.forEach(p => p.style.display = 'none');
        const target = document.getElementById(tab.dataset.tab);
        if (target) target.style.display = '';
      });
    });
  }

  // ============================ FAQ accordion ============================
  function initFAQ() {
    document.querySelectorAll('.faq-item').forEach(item => {
      const q = item.querySelector('.faq-q');
      if (!q) return;
      q.addEventListener('click', () => item.classList.toggle('open'));
    });
  }

  // ============================ AJAX Cart Add ============================
  function initAjaxCart() {
    document.addEventListener('submit', async function (e) {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      console.log('[IZNORA Cart] ATC submit intercepted', form);
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '⏳ Adding…'; }
      try {
        const formData = new FormData(form);
        const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        const res = await fetch(cartAddUrl + '.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Add to cart failed (status ' + res.status + ')');
        }
        const addedItem = await res.json();
        console.log('[IZNORA Cart] Added:', addedItem);

        // OPEN DRAWER IMMEDIATELY (don't wait for refresh) — cart drawer is the visual feedback
        openCartDrawer();

        if (btn) { btn.innerHTML = '✓ Added!'; }
        setTimeout(() => { if (btn) { btn.innerHTML = originalText; btn.disabled = false; } }, 1500);

        // Refresh cart in background (non-blocking)
        refreshCart().catch(err => console.warn('[IZNORA Cart] refresh failed:', err));
      } catch (err) {
        console.error('[IZNORA Cart] ATC error:', err);
        // Only show toast on errors (still useful)
        showToast(err.message || 'Could not add to cart', 'error');
        if (btn) { btn.innerHTML = originalText; btn.disabled = false; }
      }
    });
  }

  async function refreshCart() {
    try {
      const cartRes = await fetch(window.routes.cart_url + '.js');
      const cart = await cartRes.json();
      updateCartTotals(cart);
      // Re-render drawer body. `?section_id=` renders the section FILE in isolation,
      // which works for layout/static sections like cart-drawer (the JSON `?sections=`
      // form can skip them). Returns raw HTML containing #CartDrawerBody.
      const bodyEl = document.getElementById('CartDrawerBody');
      if (bodyEl) {
        const sectionRes = await fetch('/?section_id=cart-drawer');
        if (sectionRes.ok) {
          const html = await sectionRes.text();
          if (html) _replaceDrawerBody(html);
        }
      }
    } catch (e) { console.error('refreshCart', e); }
  }

  // Update cart count badges + drawer subtotal from a cart object
  function updateCartTotals(cart) {
    if (!cart) return;
    if (typeof cart.item_count === 'number') {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      document.querySelectorAll('[data-cart-drawer-count]').forEach(el => {
        el.textContent = cart.item_count;
      });
    }
    if (typeof cart.total_price === 'number') {
      document.querySelectorAll('[data-cart-drawer-subtotal]').forEach(el => {
        el.textContent = formatMoney(cart.total_price);
      });
      updateCartProgress(cart.total_price);
    }
  }

  // Free-shipping progress bar — single $50 threshold in USD,
  // converted to the visitor's presentment currency via Shopify.currency.rate
  function updateCartProgress(totalCents) {
    const wrap = document.querySelector('[data-cart-progress]');
    if (!wrap || typeof totalCents !== 'number') return;
    const rate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1') || 1;
    const ship = Math.round(5000 * rate);
    const fill = wrap.querySelector('[data-progress-fill]');
    const msg = wrap.querySelector('[data-progress-msg]');
    const left = Math.max(0, ship - totalCents);
    const pct = Math.min(100, Math.round((totalCents / ship) * 100));
    if (fill) fill.style.width = pct + '%';
    wrap.classList.toggle('cd-ship--done', left <= 0);
    if (msg) {
      msg.innerHTML = left > 0
        ? 'Add <strong>' + formatMoney(left) + '</strong> for FREE shipping'
        : '✓ You’ve unlocked FREE shipping!';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const progressWrap = document.querySelector('[data-cart-progress]');
    if (progressWrap) updateCartProgress(parseInt(progressWrap.dataset.initialTotal || '0', 10));
  });

  // Replace inner HTML of #CartDrawerBody from a full cart-drawer section HTML string
  function _replaceDrawerBody(sectionHtml) {
    const bodyEl = document.getElementById('CartDrawerBody');
    if (!bodyEl) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = sectionHtml;
    const newBody = tmp.querySelector('#CartDrawerBody');
    if (!newBody) {
      // Dumping the raw section HTML here would nest a second #CartDrawer
      // inside the body (duplicate IDs, stale line refs). Keep old DOM instead.
      console.warn('[IZNORA Cart] section HTML missing #CartDrawerBody — skipping replace');
      return;
    }
    bodyEl.innerHTML = newBody.innerHTML;
  }

  // Update drawer body from a /cart/change.js response that included `sections`
  function updateDrawerFromSections(cart) {
    if (!cart || !cart.sections) return;
    const html = cart.sections['cart-drawer'];
    if (html) _replaceDrawerBody(html);
  }

  // ============================ Cart Drawer ============================
  function initCartDrawer() {
    // ALWAYS attach open/close listeners — even if drawer not in DOM (will fallback to /cart)
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) {
        e.preventDefault();
        openCartDrawer();
      } else if (e.target.closest('[data-cart-close]')) {
        closeCartDrawer();
      }
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeCartDrawer();
    });

    const drawer = document.getElementById('CartDrawer');
    if (!drawer) {
      console.warn('[IZNORA Cart] CartDrawer not in layout. Add {% section "cart-drawer" %} to layout/theme.liquid');
      return;
    }

    // Quantity / remove inside drawer.
    // Identify the line by item KEY (shift-proof); line index is a fallback.
    drawer.addEventListener('click', async function (e) {
      // Drawer upsell: one-click add accessory
      const upsellBtn = e.target.closest('[data-drawer-upsell]');
      if (upsellBtn) {
        e.preventDefault();
        const variantId = parseInt(upsellBtn.dataset.drawerUpsell, 10);
        if (!variantId) return;
        upsellBtn.disabled = true;
        upsellBtn.textContent = '…';
        try {
          const res = await fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Could not add item');
          }
          await refreshCart();
        } catch (err) {
          console.error('[IZNORA Cart] drawer upsell failed:', err);
          showToast(err.message || 'Could not add item', 'error');
          upsellBtn.disabled = false;
          upsellBtn.textContent = '＋';
        }
        return;
      }

      const lineEl = e.target.closest('[data-cart-line]');
      if (!lineEl) return;
      const ref = _lineRef(lineEl);
      const qtyInput = lineEl.querySelector('[data-cart-qty]');

      if (e.target.matches('[data-cart-decrease]')) {
        e.preventDefault();
        const newQty = Math.max(0, parseInt(qtyInput.value, 10) - 1);
        await changeCart(ref, newQty);
      } else if (e.target.matches('[data-cart-increase]')) {
        e.preventDefault();
        const newQty = parseInt(qtyInput.value, 10) + 1;
        await changeCart(ref, newQty);
      } else if (e.target.matches('[data-cart-remove]')) {
        e.preventDefault();
        await changeCart(ref, 0);
      }
    });
    drawer.addEventListener('change', async function (e) {
      const qtyInput = e.target.closest('[data-cart-qty]');
      if (!qtyInput) return;
      const lineEl = qtyInput.closest('[data-cart-line]');
      if (!lineEl) return;
      const q = parseInt(qtyInput.value, 10);
      if (!Number.isFinite(q) || q < 0) { await refreshCart(); return; } // cleared/garbage input → resync
      await changeCart(_lineRef(lineEl), q);
    });
  }

  // ============================ Cart Page (full page /cart) ============================
  // Delegated qty handlers also work on the cart page (any [data-cart-line] outside the drawer)
  document.addEventListener('click', async function (e) {
    const lineEl = e.target.closest('[data-cart-line]:not(.cart-drawer__item)');
    if (!lineEl) return;
    const ref = _lineRef(lineEl);
    const qtyInput = lineEl.querySelector('[data-cart-qty]');
    if (!qtyInput) return;

    if (e.target.matches('[data-cart-decrease]')) {
      e.preventDefault();
      const newQty = Math.max(0, parseInt(qtyInput.value, 10) - 1);
      await changeCartAndReload(ref, newQty);
    } else if (e.target.matches('[data-cart-increase]')) {
      e.preventDefault();
      const newQty = parseInt(qtyInput.value, 10) + 1;
      await changeCartAndReload(ref, newQty);
    } else if (e.target.matches('[data-cart-remove]')) {
      e.preventDefault();
      await changeCartAndReload(ref, 0);
    }
  });

  // Read a stable reference to a cart line: { key, line }.
  // key  = line item key from data-key (shift-proof, preferred)
  // line = 1-based index from data-cart-line (fallback)
  function _lineRef(lineEl) {
    if (!lineEl) return { key: '', line: NaN };
    return {
      key: (lineEl.getAttribute('data-key') || '').trim(),
      line: parseInt(lineEl.getAttribute('data-cart-line'), 10)
    };
  }

  // POST to /cart/change.js. Tries the item KEY first, then falls back to the
  // line INDEX if Shopify rejects the key — so whichever identifier is valid wins.
  // change.js is atomic: a non-OK response means nothing changed, so retrying is safe.
  async function _postCartChange(ref, quantity, wantSections) {
    const attempts = [];
    if (ref && ref.key) attempts.push({ id: ref.key });
    if (ref && Number.isFinite(ref.line) && ref.line > 0) attempts.push({ line: ref.line });
    if (!attempts.length) throw new Error('Could not identify cart item');

    let lastErr = null;
    for (let i = 0; i < attempts.length; i++) {
      const body = Object.assign({ quantity }, attempts[i]);
      if (wantSections) {
        body.sections = 'cart-drawer';
        body.sections_url = window.location.pathname || '/';
      }
      const res = await fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) return data;
      lastErr = new Error(data.description || data.message || 'Cart update failed');
      console.warn('[IZNORA Cart] change attempt failed, trying fallback:', body, lastErr.message);
    }
    throw lastErr || new Error('Cart update failed');
  }

  // Only one cart mutation may be in flight at a time. Re-entrant clicks are
  // dropped (not queued — a queued +/- would replay a stale quantity).
  let _cartBusy = false;

  function _setDrawerBusy(busy) {
    const d = document.getElementById('CartDrawer');
    if (d) d.classList.toggle('cart-drawer--busy', busy);
  }

  // An error meaning "this line no longer exists" = the DOM was stale, not a
  // real failure. Resync silently instead of scaring the user with a toast.
  function _isStaleLineError(e) {
    return /line parameter|cannot find variant|not found/i.test((e && e.message) || '');
  }

  async function changeCartAndReload(ref, quantity) {
    if (_cartBusy) return;
    _cartBusy = true;
    try {
      await _postCartChange(ref, quantity, false);
      window.location.reload();
    } catch (e) {
      console.error('[IZNORA Cart] change failed:', e);
      if (_isStaleLineError(e)) { window.location.reload(); return; }
      showToast(e.message || 'Could not update cart', 'error');
    } finally {
      _cartBusy = false;
    }
  }

  async function changeCart(ref, quantity) {
    if (_cartBusy) return;
    _cartBusy = true;
    _setDrawerBusy(true);
    try {
      const data = await _postCartChange(ref, quantity, true);
      // Prefer the section HTML returned atomically with the change…
      if (data && data.sections && data.sections['cart-drawer']) {
        updateDrawerFromSections(data);
        updateCartTotals(data);
      } else {
        // …otherwise fall back to a separate refresh fetch.
        await refreshCart();
      }
    } catch (e) {
      console.error('[IZNORA Cart] change failed:', e);
      if (_isStaleLineError(e)) {
        await refreshCart(); // drawer DOM was stale — resync silently
      } else {
        showToast(e.message || 'Could not update cart', 'error');
      }
    } finally {
      _cartBusy = false;
      _setDrawerBusy(false);
    }
  }

  function openCartDrawer() {
    const d = document.getElementById('CartDrawer');
    if (!d) {
      console.warn('[IZNORA Cart] CartDrawer element not in DOM — falling back to /cart');
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }
    // Add BOTH class names for max compatibility with both old (.cart-drawer--open) and new (.is-open) CSS
    d.classList.add('is-open');
    d.classList.add('cart-drawer--open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('zyl-drawer-open');
    console.log('[IZNORA Cart] Drawer opened');
  }
  function closeCartDrawer() {
    const d = document.getElementById('CartDrawer');
    if (!d) return;
    d.classList.remove('is-open');
    d.classList.remove('cart-drawer--open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('zyl-drawer-open');
  }

  // ============================ Mobile Menu ============================
  function initMobileMenu() {
    const menu = document.getElementById('mobileMenu');
    if (!menu) return;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]')) {
        e.preventDefault();
        menu.classList.add('is-open');
        menu.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      } else if (e.target.closest('[data-menu-close]')) {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  }

  // ============================ Product Upsell ============================
  function initUpsell() {
    const upsell = document.querySelector('[data-upsell]');
    if (!upsell) return;
    const items = upsell.querySelectorAll('[data-upsell-item]');
    const totalEl = upsell.querySelector('[data-upsell-total]');
    const saveEl = upsell.querySelector('[data-upsell-save]');
    const addBtn = upsell.querySelector('[data-upsell-add]');

    function recalc() {
      let total = 0;
      let count = 0;
      items.forEach(item => {
        if (item.querySelector('.upsell__check').checked) {
          // Shopify {{ variant.price }} is already in cents (× 100), so no extra multiplication
          total += parseInt(item.dataset.productPrice, 10) || 0;
          count++;
        }
      });
      totalEl.textContent = count > 0 ? formatMoney(total) : '—';
      saveEl.textContent = count > 1 ? `You save ${formatMoney(Math.round(total * 0.15))} (15%)` : 'Add 2+ to save 15%';
      addBtn.disabled = count === 0;
      addBtn.textContent = count === 0 ? '+ Select items above' : `+ Add ${count} to Cart`;
    }
    items.forEach(item => {
      item.querySelector('.upsell__check').addEventListener('change', recalc);
    });
    recalc();

    addBtn.addEventListener('click', async function () {
      const selected = Array.from(items).filter(i => i.querySelector('.upsell__check').checked);
      if (!selected.length) return;
      addBtn.disabled = true;
      addBtn.textContent = '⏳ Adding…';
      try {
        let failed = 0;
        for (const item of selected) {
          const res = await fetch(window.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.dataset.variantId, quantity: 1 })
          });
          if (!res.ok) failed++;
        }
        await refreshCart();
        if (failed > 0) showToast(failed + ' item(s) could not be added (sold out?)', 'error');
        addBtn.textContent = failed === selected.length ? '✗ Unavailable' : '✓ Added!';
        setTimeout(() => recalc(), 1500);
        openCartDrawer();
        // Toast removed — cart drawer is visual feedback
      } catch (e) {
        showToast('Could not add upsell items', 'error');
        addBtn.disabled = false;
        recalc();
      }
    });
  }

  // ============================ Toast Notifications ============================
  function showToast(message, type = 'info') {
    const container = document.getElementById('ToastContainer');
    if (!container) { alert(message); return; }
    const toast = document.createElement('div');
    toast.className = `toast toast--${type}`;
    toast.innerHTML = `<span class="toast__icon">${type === 'success' ? '✓' : type === 'error' ? '⚠' : 'ℹ'}</span><span>${message}</span>`;
    container.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('toast--show'));
    setTimeout(() => {
      toast.classList.remove('toast--show');
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }

  // ============================ Helpers ============================
  // Currencies displayed WITHOUT decimal places (VND, JPY, etc.)
  // NOTE: Shopify ALWAYS stores prices as integer × 100 internally (even for
  // zero-decimal currencies), so we ALWAYS divide by 100 before formatting.
  // The difference for zero-decimal currencies is just DISPLAY (no decimals shown).
  const ZERO_DECIMAL = ['VND', 'JPY', 'KRW', 'CLP', 'PYG', 'BIF', 'DJF', 'GNF', 'KMF', 'MGA', 'RWF', 'XAF', 'XOF', 'XPF', 'UGX'];

  // Locale hint per currency for nicer formatting (matches Liquid money filter style)
  const CURRENCY_LOCALE = {
    VND: 'vi-VN', JPY: 'ja-JP', KRW: 'ko-KR', CNY: 'zh-CN', THB: 'th-TH',
    GBP: 'en-GB', EUR: 'de-DE', USD: 'en-US', AUD: 'en-AU', CAD: 'en-CA'
  };

  function formatMoney(cents) {
    if (cents === null || cents === undefined || isNaN(cents)) return '';
    const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    const isZeroDec = ZERO_DECIMAL.indexOf(cur) > -1;
    // Shopify stores all prices × 100 — always divide by 100 to get the actual amount
    const amount = cents / 100;
    const locale = CURRENCY_LOCALE[cur] || window.navigator.language || 'en-US';
    try {
      const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: cur,
        minimumFractionDigits: isZeroDec ? 0 : 2,
        maximumFractionDigits: isZeroDec ? 0 : 2
      });
      // Append ISO code to disambiguate $-currencies (USD/CAD/AUD) — matches Liquid money_with_currency.
      // Skip when Intl already rendered the code (e.g. AED shows as "AED 1,550.40") to avoid "AED … AED"
      const out = formatter.format(amount);
      return out.indexOf(cur) !== -1 ? out : out + ' ' + cur;
    } catch {
      return '$' + amount.toFixed(isZeroDec ? 0 : 2) + ' ' + cur;
    }
  }

  // Expose for debugging
  window.IZNORA = { openCartDrawer, closeCartDrawer, refreshCart, showToast };

})();
